module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "game-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "profile-details-container"
    }
  }, [(!_vm.gameDoesntExist) ? _c('game-details') : _vm._e()], 1), _vm._v(" "), (!_vm.gameDoesntExist) ? _c('section', {
    attrs: {
      "id": "game-page-content"
    }
  }, [(!_vm.gameDoesntExist) ? _c('nav', {
    staticClass: "switch profile-page-navigation",
    attrs: {
      "id": "game-page-navigation"
    }
  }, [_c('router-link', {
    class: {
      active: _vm.selectedSubpage === 'RecentActivity'
    },
    attrs: {
      "to": '/Game/' + _vm.$route.params.game,
      "title": "Recent Activity"
    }
  }, [_vm._v("Recent Activity")]), _vm._v(" "), _c('router-link', {
    class: {
      active: _vm.selectedSubpage === 'Media'
    },
    attrs: {
      "to": '/Game/' + _vm.$route.params.game + '/Media',
      "title": "Media"
    }
  }, [_vm._v("Media")]), _vm._v(" "), _c('router-link', {
    class: {
      active: _vm.selectedSubpage === 'Members'
    },
    attrs: {
      "to": '/Game/' + _vm.$route.params.game + '/Members',
      "title": "Members"
    }
  }, [_vm._v("Members")]), _vm._v(" "), _c('router-link', {
    class: {
      active: _vm.selectedSubpage === 'Forums'
    },
    attrs: {
      "to": '/Game/' + _vm.$route.params.game + '/Forums',
      "title": "Forums"
    }
  }, [_vm._v("Forums")]), _vm._v(" "), _c('router-link', {
    class: {
      active: _vm.selectedSubpage === 'Followers'
    },
    attrs: {
      "to": '/Game/' + _vm.$route.params.game + '/Followers',
      "title": "Followers"
    }
  }, [_vm._v("Followers")])], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "game-id": _vm.gameId,
      "is-member": _vm.isMember,
      "is-moderator": _vm.isModerator,
      "is-owner": _vm.isOwner
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.gameDoesntExist) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v("This Game Doesn't Exist")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-144def7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/GamePage.vue
// module id = 826
// module chunks = 2